<template>
    <div class="login-register">
        <div class="form-ipt">
            <h1 class="logo"><router-link to="/"><img :src="require('@/assets/images/logo.png')" alt=""></router-link></h1>
            <div class="form-title">忘记密码</div>
            <div class="form-cont">

                <div class="form-item">
                    <el-input placeholder="请输入手机号" v-model="registerPhoneNum"></el-input>
                </div>
                <div class="form-item">
                    <el-input class="left-ipt" v-model="registerYzm" placeholder="请输入6位短信验证码"></el-input>
                    <el-button
                            class="right-btn"
                            :type="time === 0 ? 'primary' : 'info'"
                            :disabled="time === 0 ? false : true"
                            @click="setTime"
                    >
                        {{time === 0 ? '发送验证码' : time + '秒后重发'}}
                    </el-button>
                </div>
                <div class="form-item">
                    <el-input class="left-ipt" v-model="password" placeholder="请输入密码" show-password minlength="6" show-word-limit></el-input>
                </div>
                <div class="form-item">
                    <el-input class="left-ipt" v-model="repassword" placeholder="请确认密码" show-password  minlength="6" show-word-limit></el-input>
                </div>
                <div class="login-btn">
                    <el-button class="btn newbtn" size="medium" @click="login" :loading="loading">提 交</el-button>
                </div>
                <div class="no-pass">
                    已有账号 <router-link to="/login">直接登录</router-link>
                </div>
                <div class="back-index"><router-link to="/">返回首页</router-link></div>
            </div>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import axios from 'axios';
    import vue from 'vue';
    vue.prototype.$axios = axios;
    import qs from 'qs';
    vue.prototype.qs = qs;
    import VueCookies from 'vue-cookies'
    vue.use(VueCookies);
    export default {
        components: {

        },
        data () {
            return {
                loading:false,
                nickname:"",
                registerPhoneNum: '',
                registerImgCode: '',
                registerCheckImg: '',
                registerYzm: '',
                time: 0,
                fromUrl:"",
                fromQuery:"",
                password: '',
                repassword: '',
                xieyi: true
            }
        },
        created:function(){
            this.check_code();
            if(window.location.href.indexOf("callback")!=-1){
                let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
                this.fromUrl=decodeURIComponent(url);
            }
        },

        methods: {
            // 倒计时
            setTime () {
                let _this=this;
                let url='/api/checkcode?time='+ new Date().getMilliseconds();

                let postData = {
                    'mobile':this.registerPhoneNum,
                    'captchaValue':this.registerImgCode
                }

                if(!this.registerPhoneNum){
                    _this.$message({
                        message: '手机号码不能为空',
                        type: 'warning'
                    });
                    return false;
                }else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                    if (!reg.test(this.registerPhoneNum)) {
                        _this.$message({
                            message: '手机号码格式有误',
                            type: 'warning'
                        });
                        return false;
                    }else{
                        let url2='/api/checkIsReg?mobile='+this.registerPhoneNum+'&time='+ new Date().getMilliseconds();
                        _this.$axios.get(url2).then(function (result1) {
                            if(result1.data.code==1){
                                _this.$axios.post(url, qs.stringify(postData)).then(function(result){
                                    if(result.data==1){
                                        _this.$message({
                                            message: '图形验证码不能为空',
                                            type: 'warning'
                                        });
                                        return false;
                                    }
                                    if(result.data==2){
                                        _this.$message({
                                            message: '图形验证码填写错误',
                                            type: 'warning'
                                        });
                                        return false;
                                    }
                                    if(result.data==-1){
                                        _this.time = 60
                                        _this.interval = setInterval(() => {
                                            _this.time = _this.time - 1
                                            if(_this.time === 0) {
                                                clearInterval(_this.interval)
                                            }
                                        }, 1000)
                                    }
                                })
                            }else{
                                _this.$message({
                                    message: '手机号尚未注册',
                                    type: 'warning'
                                });
                                return false;
                            }

                        })

                    }
                }


            },

            check_code:function () {
                let _this=this;
                let time= new Date().getMilliseconds();
                let url='/api/checkcode?time='+time;
                this.$axios.get(url,{responseType: 'arraybuffer'}).then(function(result){
                    let img_url='data:image/png;base64,' + btoa(new Uint8Array(result.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                    _this.registerCheckImg=img_url;
                })
            },
            login:function () {
                let domain = document.domain;
                console.log(domain)
                let _this=this;
                _this.loading=true;
                let url='/api/setPassword?time='+new Date().getMilliseconds();
                let postData = {

                    'mobile':this.registerPhoneNum,
                    'captchaValue':this.registerYzm,
                    'newPassword':this.password,
                }
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
              if(!this.registerPhoneNum){
                    _this.$message({
                        message: '手机号码不能为空',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else if (!reg.test(this.registerPhoneNum)) {
                    _this.$message({
                        message: '手机号码格式有误',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else if(!this.password){
                    _this.$message({
                        message: '密码不能为空',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else if(this.password.length<8){
                    _this.$message({
                        message: '密码要大于8位',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else if(this.password.length>44){
                  _this.$message({
                      message: '密码过长',
                      type: 'warning'
                  });
                  _this.loading=false;
                  return false;
              }else if(this.password!=this.repassword){
                    _this.$message({
                        message: '密码与确认密码不一致',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else if(!this.registerYzm){
                    _this.$message({
                        message: '手机验证码不能为空',
                        type: 'warning'
                    });
                    _this.loading=false;
                    return false;
                }else{

                        console.log(postData)
                        this.$axios.post(url, qs.stringify(postData)).then(function(result){
                            console.log(result.data)
                            if(result.data.code==1){
                                _this.$message({
                                    message: '修改成功，请用新密码登录',
                                    type: 'success'
                                });
                                _this.$router.push("/passlogin")
                            }else{
                                _this.$message({
                                    message:result.data.message ,
                                    type: 'warning'
                                });
                            }
                            _this.loading=false;
                        })

                }
            },

        },
        beforeDestroy () {
            clearInterval(this.interval)
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/login.less";
</style>
